import type { PurchaseOrderItem } from '@/domain/inventory';

export const KIT_BOX_SKU = '35223';
export const KIT_CONTROL_SKU = '35220';

export const isKitBoxItem = (item: PurchaseOrderItem): boolean =>
  item.productType === 'caja' || item.sku === KIT_BOX_SKU;

export const isSimItem = (item: PurchaseOrderItem): boolean =>
  item.isSim || item.productType === 'sim';

export type ReceptionScanMode = 'single' | 'kit';

export const getReceptionScanMode = (item: PurchaseOrderItem | undefined): ReceptionScanMode =>
  item && isKitBoxItem(item) ? 'kit' : 'single';
